import authenticatedAxios from "../services/authenticatedAxios";

export const fetchNotificationSettings = async () => {
  // Backend resolves dealerShipId from authenticated session Redis.
  const res = await authenticatedAxios.get("/api/v1/dealerShipDetails/dealer/notificationSettings");
  return res.data;
};

export const saveNotificationSettings = async (payload) => {
  const body = {
    usageRange: payload.usageRange,
    emailEnabled: Boolean(payload.emailEnabled),
  };
  const res = await authenticatedAxios.put("/api/v1/dealerShipDetails/dealer/notificationSettings", body);
  return res.data;
};
